<template>
  <div class="tree-node">
    <div class="node-row" @click="toggleExpand">
      <span class="expand-icon" :class="{ 'is-leaf': !hasChildren, 'is-expand': expanded }">
        <i v-if="hasChildren" :class="expanded ? 'el-icon-remove-outline' : 'el-icon-circle-plus-outline'"></i>
        <i v-else class="el-icon-user"></i>
      </span>

      <div class="node-cell name-cell">
        <span class="nickname">{{ node.nickname || node.username }}</span>
        <span class="username">@{{ node.username }}</span>
      </div>

      <div class="node-cell tag-cell">
        <span v-if="node.agentLevel === 1" class="badge badge-lv1">一级</span>
        <span v-else-if="node.agentLevel === 2" class="badge badge-lv2">二级</span>
        <span v-else-if="node.agentLevel === 3" class="badge badge-lv3">三级</span>
        <span v-if="node.groupName" class="badge badge-group">{{ node.groupName }}</span>
        <span v-if="node.parentNickname" class="badge badge-parent">←{{ node.parentNickname }}</span>
      </div>

      <div class="node-cell role-cell">
        <span v-if="node.roleType === 'SUPER_ADMIN'" class="badge badge-admin">管理员</span>
        <span v-else-if="node.roleType === 'SUB_ADMIN'" class="badge badge-sub">分后台</span>
        <span v-else class="badge badge-user">用户</span>
      </div>

      <div class="node-cell perm-cell">
        <span class="dot" :class="node.canImport === 1 ? 'dot-green' : 'dot-gray'"></span>
        <span class="label">{{ node.canImport === 1 ? '可导入' : '只读' }}</span>
        <span class="sep">|</span>
        <span class="label">{{ incomeLabel }}</span>
      </div>

      <div class="node-cell video-cell">
        <template v-if="node.boundVideoIds && node.boundVideoIds.length > 0">
          <span class="badge badge-video" v-for="vid in node.boundVideoIds.slice(0,2)" :key="vid">{{ vid }}</span>
          <span v-if="node.boundVideoIds.length > 2" class="more">+{{ node.boundVideoIds.length - 2 }}</span>
        </template>
        <span v-else class="none">-</span>
      </div>

      <div class="node-cell time-cell">{{ (node.createTime || '').replace('T', ' ') }}</div>

      <div class="node-cell action-cell" @click.stop>
        <el-button v-if="node.roleType !== 'SUPER_ADMIN'" type="text" size="mini" @click="$emit('edit', node)">编辑</el-button>
        <el-button v-if="node.roleType !== 'SUPER_ADMIN'" type="text" size="mini" @click="$emit('toggle', node)">
          {{ node.status === 1 ? '禁用' : '启用' }}
        </el-button>
        <el-button v-if="node.roleType !== 'SUPER_ADMIN'" type="text" size="mini" style="color:#67c23a" @click="$emit('add-child', node)">+ 下级</el-button>
        <el-button v-if="node.roleType !== 'SUPER_ADMIN'" type="text" size="mini" style="color:#e6a23c" @click="$emit('query-revenue', node)">收益</el-button>
        <el-button v-if="node.roleType !== 'SUPER_ADMIN'" type="text" size="mini" style="color:#f56c6c" @click="$emit('delete', node)">删除</el-button>
      </div>
    </div>

    <transition name="tree-fade">
      <div v-if="expanded && hasChildren" class="node-children">
        <user-node
          v-for="child in node.children"
          :key="child.id"
          :node="child"
          :is-super-admin="isSuperAdmin"
          @delete="$emit('delete', $event)"
          @toggle="$emit('toggle', $event)"
          @edit="$emit('edit', $event)"
          @add-child="$emit('add-child', $event)"
          @query-revenue="$emit('query-revenue', $event)"
          @refresh="$emit('refresh')"
        />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'UserNode',
  props: {
    node: { type: Object, required: true },
    isSuperAdmin: { type: Boolean, default: false }
  },
  data() {
    return { expanded: true }
  },
  computed: {
    hasChildren() {
      return this.node.children && this.node.children.length > 0
    },
    incomeLabel() {
      const map = { BOTH: '全部收益', ONLY_TOTAL: '仅总收益', ONLY_AFTER: '仅分成' }
      return map[this.node.incomePermission] || this.node.incomePermission
    }
  },
  methods: {
    toggleExpand() {
      if (this.hasChildren) {
        this.expanded = !this.expanded
      }
    }
  }
}
</script>

<style scoped>
.tree-node { font-size: 13px; }

.node-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  margin: 1px 0;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  cursor: pointer;
  transition: all .15s;
  line-height: 1.6;
}
.node-row:hover { background: #f0f7ff; border-color: #c6e2ff; }

.expand-icon {
  width: 24px; height: 24px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  font-size: 15px; color: #409eff;
  border-radius: 50%;
  transition: all .2s;
}
.expand-icon.is-leaf { color: #c0c4cc; font-size: 14px; }
.expand-icon.is-expand { color: #e6a23c; }
.expand-icon:hover { background: #ecf5ff; }

.node-cell { flex-shrink: 0; }
.name-cell { width: 140px; }
.nickname { font-weight: 600; color: #303133; }
.username { color: #909399; font-size: 11px; margin-left: 4px; }

.tag-cell { width: 100px; display: flex; gap: 4px; align-items: center; }

.badge {
  display: inline-block; padding: 0 6px; height: 20px; line-height: 20px;
  border-radius: 3px; font-size: 11px; white-space: nowrap;
}
.badge-lv1 { background: #e1f3d8; color: #67c23a; }
.badge-lv2 { background: #faecd8; color: #e6a23c; }
.badge-lv3 { background: #fde2e2; color: #f56c6c; }
.badge-group { background: #e8f5e9; color: #388e3c; }
.badge-parent { background: #f4f4f5; color: #909399; }
.badge-admin { background: #fde2e2; color: #f56c6c; }
.badge-sub { background: #faecd8; color: #e6a23c; }
.badge-user { background: #ecf5ff; color: #409eff; }
.badge-video { background: #f0f2f5; color: #606266; font-size: 10px; }

.role-cell { width: 65px; }
.perm-cell { width: 130px; display: flex; align-items: center; gap: 5px; color: #606266; }
.perm-cell .label { font-size: 12px; }
.perm-cell .sep { color: #dcdfe6; }
.dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }
.dot-green { background: #67c23a; }
.dot-gray { background: #c0c4cc; }

.video-cell { width: 140px; display: flex; align-items: center; gap: 3px; flex-wrap: wrap; }
.video-cell .none { color: #c0c4cc; }
.video-cell .more { color: #409eff; font-size: 11px; }

.time-cell { width: 155px; color: #909399; font-size: 12px; }

.action-cell { display: flex; gap: 2px; }

.node-children {
  margin-left: 20px;
  padding-left: 16px;
  border-left: 2px solid #e4e7ed;
  position: relative;
}
.node-children::before {
  content: '';
  position: absolute;
  left: -2px;
  top: 9px;
  width: 14px;
  height: 2px;
  background: #e4e7ed;
}

.tree-fade-enter-active, .tree-fade-leave-active {
  transition: all .2s ease;
}
.tree-fade-enter, .tree-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
